









import { defineComponent, ref } from "@vue/composition-api";
import { useGroups } from "@/hooks/useGroups";
import useHideMainMenu from "@/hooks/useHideMainMenu";
import MassMessageEdit from "@/components/MassMessageEdit";

export default defineComponent({
  name: "PageMassMessage",
  components: { MassMessageEdit },
  props: { ids: { type: Array as () => string[] } },
  setup(_, { root }) {
    useHideMainMenu();

    const loading = ref(false);

    const { groups, getMyGroups } = useGroups();

    const getData = async () => {
      try {
        loading.value = true;
        await getMyGroups();
      } finally {
        loading.value = false;
      }
    };

    getData();

    const onSave = () => root.$router.back();

    return {
      groups,
      loading,
      onSave,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm: any) => {
      if (!vm.allowMassMessage && vm.isMassMessage) {
        vm.$router.replace(from);
      }
    });
  },
});
